
export function cleanObject(obj) {
  if (obj === null || obj === undefined) {
    return undefined; // Return undefined for null or undefined
  }

  if (typeof obj === 'object') {
    // Handle arrays
    if (Array.isArray(obj)) {
      // Remove any empty arrays
      obj = obj.filter(item => item !== undefined && item !== null && item !== '' && !(Array.isArray(item) && item.length === 0) && !(typeof item === 'object' && Object.keys(item).length === 0));
    } else {
      // For objects, filter out empty string, empty object, empty array, null, and undefined
      Object.keys(obj).forEach(key => {
        let value = obj[key];

        // Trim string values
        if (typeof value === 'string') {
          value = value.trim();
        }

        if (value === '' || value === null || value === undefined || 
            (typeof value === 'object' && Object.keys(value).length === 0) || 
            (Array.isArray(value) && value.length === 0) ||
            Number.isNaN(value)) {
          delete obj[key]; // Remove the key if the value meets the criteria
        } else {
          obj[key] = cleanObject(value); // Recursively clean nested objects
        }
      });
    }
  }
  return obj;
}